import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../../util/Axios';
import { RegistrationStepper } from './RegistrationStepper';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import * as actions from '../../store/actions/GlobalActions';
import { grey } from '@mui/material/colors';
import { PublicHeader } from '../../components/PublicHeader';
import { useTranslation } from 'react-i18next';
import { COUNTRIES } from '../../util/Constants';

export function AcceptInvitation() {
  const { i18n } = useTranslation();
  const params = useParams();
  const dispatch = useDispatch();
  const [invitationLoaded, setInvitationLoaded] = useState(false);

  useEffect(() => {
    axios
      .get(`invitations/${params.token}`)
      .then((resp) => {
        if (resp.data?.status === 'ACCEPTED') {
          dispatch({ type: actions.FINISH_REGISTRATION });
        } else if (resp.data?.status === 'INVALID') {
          dispatch({ type: actions.INVALID_INVITATION });
        } else {
          dispatch({ type: actions.OPEN_INVITATION, payload: resp.data });
        }
        setInvitationLoaded(true);
        i18n.changeLanguage(COUNTRIES[resp.data.country]?.lng ?? 'en');
      })
      .catch((error) => {
        dispatch({ type: actions.INVALID_INVITATION });
        setInvitationLoaded(true);
      });
  }, [dispatch, params.token, i18n]);

  return (
    <>
      <PublicHeader />
      <Box
        bgcolor="background.default"
        sx={{
          backgroundColor: grey[100],
          backgroundPosition: 'center',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {invitationLoaded ? <RegistrationStepper /> : ''}
      </Box>
    </>
  );
}
